import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SETUP_PERSONAL_ACCOUNT_LINK: `${cleanedFilename(__filename)}-personal-link`,
  SETUP_OPEN_ACCOUNT_LINK: `${cleanedFilename(__filename)}-account-link`,
};
